<kin-toaster />
<div
  #mainContent
  class="main"
  [class]="{
    xSmallScreen: xSmallScreen(),
    smallScreen: smallScreen(),
    mediumScreen: mediumScreen(),
    largeScreen: largeScreen(),
  }">
  <img [src]="'../assets/login-backgrounds/' + background" class="background" />
  <div class="content">
    @if (showLogo()) {
      <img
        class="logo"
        [style.margin-top]="heightScreen() < 1000 ? '2rem' : '10rem'"
        src="../assets/kinomap_primary_white.png"
        alt="" />
    }
    <div class="content-router">
      <router-outlet />
    </div>
  </div>
  <div class="gradient-bottom"></div>
</div>
